"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[8403],{

/***/ 39450:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ HeaderBannerContainer_HeaderBannerContainer)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/components/inputs/ButtonBase/ButtonBase.tsx
var ButtonBase = __webpack_require__(52493);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
;// CONCATENATED MODULE: ./src/compositions/banners/HeaderBannerContainer/HeaderBannerContainer.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const HeaderBannerContainer_module = ({"root":"DB633S"});
;// CONCATENATED MODULE: ./src/compositions/banners/HeaderBannerContainer/HeaderBannerContainer.tsx







var heightClassMap = {
    48: "h-48",
    56: "h-56",
    64: "h-64"
};
var HeaderBannerContainer = function(props) {
    var children = props.children, className = props.className, to = props.to, height = props.height, loading = props.loading, trackParams = props.trackParams, onClick = props.onClick, dataTestId = props["data-testid"];
    var rootClassName = (0,clsx/* default */.Z)(className, HeaderBannerContainer_module.root, "flex items-center justify-center text-white", heightClassMap[height]);
    var content = loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
        name: "32/loader"
    }) : children;
    if (to || onClick) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
            className: (0,clsx/* default */.Z)(rootClassName, "w-full"),
            to: to,
            role: "complementary",
            loading: loading,
            onClick: function() {
                (0,analytics/* track */.j)("Banner click", trackParams);
                if (typeof onClick === "function") {
                    onClick();
                }
            },
            "data-testid": dataTestId,
            children: content
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        "data-testid": dataTestId,
        role: "complementary",
        children: content
    });
};
/* harmony default export */ const HeaderBannerContainer_HeaderBannerContainer = (HeaderBannerContainer);


/***/ }),

/***/ 16221:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ LandingSubscriptionHeaderBanner_LandingSubscriptionHeaderBanner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/modules/subscription/subscribe/index.tsx
var subscribe = __webpack_require__(7138);
// EXTERNAL MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/SubscribeHeaderBannerBase.tsx + 3 modules
var SubscribeHeaderBannerBase = __webpack_require__(23235);
;// CONCATENATED MODULE: ./src/compositions/banners/LandingSubscriptionHeaderBanner/messages.ts
/* harmony default export */ const messages = ({
    discount: {
        en: "Get {discount} off your first month"
    },
    freeProduct: {
        en: "Get your free fragrance"
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/LandingSubscriptionHeaderBanner/LandingSubscriptionHeaderBanner.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var textByOffer = {
    freeProduct: {
        cookieName: constants/* default */.Z.cookieNames.freePerfumeCountdown,
        message: messages.freeProduct
    },
    discount: {
        cookieName: constants/* default */.Z.cookieNames.rootCountdown,
        message: messages.discount
    }
};
// this banner is used on landings and register page
// we show countdowns only fo some
var LandingSubscriptionHeaderBanner = function(param) {
    var _param_placement = param.placement, placement = _param_placement === void 0 ? "Header" : _param_placement, isStatic = param.isStatic;
    var _useSubscribeOffer = (0,subscribe/* useSubscribeOffer */.Hu)(), isFetching = _useSubscribeOffer.isFetching, discountText = _useSubscribeOffer.discountText, formattedPrice = _useSubscribeOffer.formattedPrice, formattedExtraShippingPrice = _useSubscribeOffer.formattedExtraShippingPrice, offerType = _useSubscribeOffer.offerType, cookieCouponCode = _useSubscribeOffer.cookieCouponCode, couponCode = _useSubscribeOffer.couponCode, eventDiscountText = _useSubscribeOffer.eventDiscountText, handleSubscribeClick = _useSubscribeOffer.handleSubscribeClick;
    // ATTN we don't show default coupon if banner is static, because it's not saved
    if (isStatic && !cookieCouponCode) {
        return null;
    }
    // ATTN we show only limited amount of offers here
    if (!textByOffer[offerType]) {
        return null;
    }
    var _textByOffer_offerType = textByOffer[offerType], cookieName = _textByOffer_offerType.cookieName, message = _textByOffer_offerType.message;
    var title = _object_spread_props(_object_spread({}, message), {
        values: {
            discount: discountText,
            price: formattedPrice,
            extraShippingPrice: formattedExtraShippingPrice
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeHeaderBannerBase/* default */.Z, {
        title: title,
        loading: isFetching,
        isStatic: isStatic,
        trackParams: {
            placement: placement,
            content: "Subscribe",
            action: "link",
            link: links/* default */.ZP.subscribe,
            discount: eventDiscountText,
            coupon: couponCode
        },
        withCountdown: true,
        countdownCookieName: cookieName,
        onClick: handleSubscribeClick
    });
};
/* harmony default export */ const LandingSubscriptionHeaderBanner_LandingSubscriptionHeaderBanner = (LandingSubscriptionHeaderBanner);


/***/ }),

/***/ 23235:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ SubscribeHeaderBannerBase_SubscribeHeaderBannerBase)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(17696);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
// EXTERNAL MODULE: ./src/compositions/banners/HeaderBannerContainer/HeaderBannerContainer.tsx + 1 modules
var HeaderBannerContainer = __webpack_require__(39450);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/hooks/useCountdown.ts
var useCountdown = __webpack_require__(53743);
;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/components/Countdown/messages.ts
/* harmony default export */ const messages = ({
    start: {
        en: "Offer ends in"
    },
    time: {
        en: "{time}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/components/Countdown/Countdown.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Countdown_module = ({"seconds":"Mngfsm","milliseconds":"DIFWZO"});
;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/components/Countdown/Countdown.tsx







var secondsFormat = "mm [min], ss [sec]";
var millisecondsFormat = "mm [min], ss.S [sec]";
var Countdown = function(param) {
    var cookieName = param.cookieName, _param_withMilliseconds = param.withMilliseconds, withMilliseconds = _param_withMilliseconds === void 0 ? true : _param_withMilliseconds;
    var countdownRef = (0,react.useRef)();
    var _useCountdown = (0,useCountdown/* default */.Z)({
        nodeRef: countdownRef,
        cookieName: cookieName,
        initialTime: 20 * 60 * 1000,
        format: withMilliseconds ? millisecondsFormat : secondsFormat,
        withMilliseconds: withMilliseconds,
        message: messages.time
    }), countdownMessage = _useCountdown.countdownMessage, isExpired = _useCountdown.isExpired;
    if (isExpired) {
        return null;
    }
    var timeClassName = (0,clsx/* default */.Z)("inline-block", withMilliseconds ? Countdown_module.milliseconds : Countdown_module.seconds, withMilliseconds ? "text-black" : null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ". ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "inline-block whitespace-nowrap text-left",
                "data-testid": "timer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                        value: messages.start
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        ref: countdownRef,
                        className: timeClassName,
                        children: countdownMessage
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const Countdown_Countdown = (Countdown);

;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/SubscribeHeaderBannerBase.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








// base banner without any logic about offer copy and countdown
var SubscribeHeaderBannerBase = function(props) {
    var title = props.title, _props_to = props.to, to = _props_to === void 0 ? links/* default */.ZP.subscribe : _props_to, trackParams = props.trackParams, loading = props.loading, onClick = props.onClick, isStatic = props.isStatic, withArrow = props.withArrow, withCountdown = props.withCountdown, withMilliseconds = props.withMilliseconds, countdownCookieName = props.countdownCookieName;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var bannerProps = {
        className: "bg-gold-50",
        height: isMobile ? 48 : 64,
        "data-testid": "subscribeBanner",
        loading: loading
    };
    if (!isStatic) {
        bannerProps.to = to;
        bannerProps.trackParams = trackParams;
        bannerProps.onClick = onClick;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderBannerContainer/* default */.Z, _object_spread_props(_object_spread({}, bannerProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                style: isMobile ? "sh6" : "sh5",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "whitespace-nowrap",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                            value: title
                        })
                    }),
                    withCountdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown_Countdown, {
                        cookieName: countdownCookieName,
                        withMilliseconds: withMilliseconds
                    })
                ]
            }),
            withArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                className: "ml-12 flex-none",
                name: "other/long-arrow-right"
            })
        ]
    }));
};
/* harmony default export */ const SubscribeHeaderBannerBase_SubscribeHeaderBannerBase = (SubscribeHeaderBannerBase);


/***/ }),

/***/ 43686:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ LandingLayout_LandingLayout)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(17382);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(73358);
// EXTERNAL MODULE: ./src/components/dataDisplay/Logo/Logo.tsx
var Logo = __webpack_require__(1041);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/compositions/banners/LandingSubscriptionHeaderBanner/LandingSubscriptionHeaderBanner.tsx + 1 modules
var LandingSubscriptionHeaderBanner = __webpack_require__(16221);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/hooks/useLandingSetup.ts
var useLandingSetup = __webpack_require__(69201);
// EXTERNAL MODULE: ./src/components/dataDisplay/BackgroundImage/BackgroundImage.tsx + 1 modules
var BackgroundImage = __webpack_require__(26713);
;// CONCATENATED MODULE: ./src/compositions/banners/TwelveDaysBanner/messages.ts
/* harmony default export */ const TwelveDaysBanner_messages = ({
    treatYourselfDesktop: {
        en: "Treat yourself this holiday season! Get {discount} off and a free case"
    },
    treatYourselfMobile: {
        en: "Treat yourself this holiday season!"
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/TwelveDaysBanner/images/mobile-background.svg
const mobile_background_namespaceObject = __webpack_require__.p + "images-svg/mobile-background_e3f70c.svg";
;// CONCATENATED MODULE: ./src/compositions/banners/TwelveDaysBanner/images/desktop-background.svg
const desktop_background_namespaceObject = __webpack_require__.p + "images-svg/desktop-background_1fd7c3.svg";
;// CONCATENATED MODULE: ./src/compositions/banners/TwelveDaysBanner/TwelveDaysBanner.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var TwelveDaysBanner = function() {
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var country = (0,user/* useUser */.a)().country;
    var _useLandingSetup = (0,useLandingSetup/* default */.Z)({
        couponCode: country === "CA" ? "HD60CA" : "HD60",
        country: country
    }), discountAmount = _useLandingSetup.discountAmount, discountPercent = _useLandingSetup.discountPercent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* default */.Z, {
        src: isMobile ? mobile_background_namespaceObject : desktop_background_namespaceObject,
        className: (0,clsx/* default */.Z)("text-center", isMobile ? "p-24" : "p-20"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            style: "h8",
            color: "white",
            message: isMobile ? TwelveDaysBanner_messages.treatYourselfMobile : _object_spread_props(_object_spread({}, TwelveDaysBanner_messages.treatYourselfDesktop), {
                values: {
                    discount: discountAmount || discountPercent
                }
            })
        })
    });
};
/* harmony default export */ const TwelveDaysBanner_TwelveDaysBanner = (TwelveDaysBanner);

// EXTERNAL MODULE: ./src/compositions/Header/Header.tsx
var Header = __webpack_require__(99025);
// EXTERNAL MODULE: ./src/compositions/Header/components/MainHeader/MainHeader.tsx + 1 modules
var MainHeader = __webpack_require__(45147);
// EXTERNAL MODULE: ./src/compositions/Footer/Footer.tsx + 6 modules
var Footer = __webpack_require__(25413);
;// CONCATENATED MODULE: ./src/layouts/LandingLayout/LandingLayout.tsx

















var LandingLayout = function(param) {
    var children = param.children;
    var pathname = (0,contexts/* usePathname */.jD)();
    var isLoggedIn = (0,user/* useUser */.a)().isLoggedIn;
    var isHomePage = pathname === links/* default */.ZP.home || pathname === links/* default */.ZP.homeMen;
    var isTwelveDaysPages = pathname === links/* default */.ZP.twelveDays;
    var isBlackFridayBannerVisible = (0,useFt/* default */.Z)(constants/* default */.Z.features.blackFridayTopHomePageBanner);
    var isCyberMondayBannerVisible = (0,useFt/* default */.Z)(constants/* default */.Z.features.cyberMondayTopHomePageBanner);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex min-h-full flex-col",
        children: [
            !isHomePage && !isTwelveDaysPages && /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingSubscriptionHeaderBanner/* default */.Z, {}),
            isTwelveDaysPages && /*#__PURE__*/ (0,jsx_runtime.jsx)(TwelveDaysBanner_TwelveDaysBanner, {}),
            isHomePage || isTwelveDaysPages ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                logoLink: null,
                withSubHeader: false,
                withSupNav: false,
                withBanner: isBlackFridayBannerVisible || isCyberMondayBannerVisible
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainHeader/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                        className: "flex-1 text-center",
                        color: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-4 flex-1 text-right",
                        children: !isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Href/* default */.Z, {
                            to: "".concat(links/* default */.ZP.login, "?redirect=").concat(encodeURIComponent(links/* default */.ZP.subscribe)),
                            onClick: function() {
                                (0,analytics/* track */.j)("Login button click");
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                tag: "span",
                                message: messages/* default */.Z.login,
                                style: "t2"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "main",
                className: "flex-auto",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ const LandingLayout_LandingLayout = (LandingLayout);


/***/ })

}]);